export default "__VITE_ASSET__D8idkE_O__"